import { Actions, createEffect, ofType } from '@ngrx/effects';

import { Injectable } from '@angular/core';
import { LoaderService } from 'src/app/services/general/loader.service';
import { merge, mergeMap } from 'rxjs';
import { OrquestadorService } from 'src/app/services/orquestador/orquestador.service';
import { catchError, concatMap, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { GeneralResume } from 'src/app/models/general-resumen';
import { loadData, loadDataSuccess, loadDataFailure, loadPolicyHolder, loadPolicyHolderSuccess, loadlead, setData } from './general.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { SARLAFT_FEEDBACK } from '@app/routes.constants';

@Injectable()
export class GeneralEffects {
    loadData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadData),
            mergeMap(({ body }) => {
                
                this.loaderService.show();
                return this.orquestadorService.postOrquestadorIntermedia(body).pipe(
                    map((response: any) => {
                        
                       
                        const { initialData, locations } = response.data;
                        
                        this.loaderService.hide();
                        return loadDataSuccess({ data: { initialData, locations } });
                    }),
                    catchError(error => {
                        
                        console.error('Effect: Error occurred', error);
                        this.loaderService.hide();
                        return of(loadDataFailure({ error }));
                    })
                );
            })
        )
    );

    loadResume$ = createEffect(() =>
            this.actions$.pipe(
                ofType(loadlead),
                mergeMap(({ body }) => {
                    const { sessionId, ...updatedBody } = body; // Remove sessionId from body
                    this.loaderService.show();
                    return this.orquestadorService.postOrquestador(body).pipe(
                        concatMap((response: any) => {
                            
                            const { leadId } = response.data;
                            //console.log('body response:', JSON.stringify(body));
                            //console.log('Response data:', response.data);
                            //console.log('Tenant value:', response.data.tenant, 'Type:', typeof response.data.tenant);
                            this.loaderService.hide();
                              
                            if(body.getLeadDuplicated){
                                
                                if (response.data && response.data.Politica) { // PANTALLA 1 PROPIETARIO
                                    return [setData({ key: 'Politica', value: response.data.Politica, merge: true })];
                                }
                                if (response.data && response.data.bitacoraId) {
                                    return [
                                        setData({ key: 'bitacoraId', value: response.data.bitacoraId, merge: true }),
                                        setData({ key: 'leadId', value: leadId, merge: true })
                                    ];
                                }
                            }

                            if(body.getTenantPolicies){
                                
                                if (response.data && response.data.tenant === false || response.data.tenant === true) {
                               
                                    return [ 
                                        setData({ key: 'tenant', value: response.data.tenant, merge: true }),
                                    ];
                                }

                               
                            }
                            


                            

                            return [setData({ key: 'leadId', value: leadId, merge: true })];
                        }),
                        catchError(error => {
                            return of(loadDataFailure({ error }));
                        })
                    );
                })
            )
        );

    // loadlead$ = createEffect(() =>
    //     this.actions$.pipe(
    //         ofType(loadlead),
    //         mergeMap(({ body }) => {
               
    //             return this.orquestadorService.postOrquestador(body).pipe(
    //                 map((response: any) => {
    //                     console.log('response.data:', JSON.stringify(response.data));
                       
    //                     const { leadId } = response.data;
    //                     console.log('leadId:', JSON.stringify(leadId));
    
    //                     if (response.data && response.data.Politica) {
    //                         return setData({ key: 'Politica', value: response.data.Politica, merge: true });
    //                     }
    
    //                     if (response.data && response.data.bitacoraId) {
    //                         console.log('response.data.bitacoraId:');
    //                         return merge(
    //                             setData({ key: 'bitacoraId', value: response.data.bitacoraId, merge: true }),
    //                             setData({ key: 'leadId', value: leadId, merge: true })
    //                         );
    //                     }
    
    //                     return setData({ key: 'leadId', value: leadId, merge: true });
    //                 }),
    //                 catchError(error => {
    //                     console.error('Effect: Error occurred', error);
    //                     return of(loadDataFailure({ error }));
    //                 })
    //             );
    //         })
    //     )
    // );
    loadPolicyHolder$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadPolicyHolder),
            map(({ PolicyHolder }) => {
                return loadPolicyHolderSuccess({ PolicyHolder });
            })
        )
    );

    constructor(
        private router: Router, private route: ActivatedRoute,
        private actions$: Actions,
        private orquestadorService: OrquestadorService,
        private loaderService: LoaderService
    ) { }

}